export default __webpack_public_path__ + "static/media/squarelogo.b95b22e5.png";